//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import styled from 'styled-components';

import HR from '@components/atoms/hr/HR';
import { Mixins } from '@theme/mixins';

export const GoogleTrackingParams = [
  { label: 'Source (utm_source)', name: 'utm_source' },
  { label: 'Vendor/Medium (utm_medium)', name: 'utm_medium' },
  { label: 'Campaign Name (utm_campaign)', name: 'utm_campaign' },
  { label: 'Campaign Content (utm_content)', name: 'utm_content' },
  { label: 'Terms Being Tested (utm_term)', name: 'utm_term' },
];

export const EDIT_TRACKING_PARAMS_PERMISSION = 'tracking_parameters:configure';
export const OVERRIDE_TRACKING_PARAMS_PERMISSION =
  'tracking_parameters:override';
export const REFERRAL_PARAM_VALUE = 'distribution_touchpoint';
export const REFERRAL_PARAM_DISPLAY_VALUE = 'Bazaarvoice Touchpoint';
export const RESERVED_PARAM_DISPLAY_VALUE = 'Bazaarvoice Reserved';

export const ParamHR = styled(HR)(
  ({ theme }) => `
  margin-bottom: ${theme.spacings[3]};
  margin-top: ${theme.spacings[1]};
`,
);

export const ParamValueHeader = styled.div(
  ({ theme }) => `
  ${Mixins.Text.UiCopy}
  line-height: 1.3;
  text-overflow: ellipsis;
  overflow-x: hidden;
  padding-bottom: ${theme.spacings[1]};
  margin-bottom: ${theme.spacings[1]};
`,
);

export const ParamValueText = styled.div(
  ({ theme }) => `
  ${Mixins.Text.BodySecondary}
  text-overflow: ellipsis;
  overflow-x: hidden;
  padding-bottom: ${theme.spacings[1]};
`,
);
